import React, { useEffect, useState } from 'react'
import { push } from 'connected-react-router'
import { connect } from 'react-redux';
import {
    // APPLICATION_MODE_NEW,
    APPLICATION_MODE_RENEW,
    REQUEST_STATUS,
    ROUTE_PATH
} from "../../app/constants"
import Navigation from '../Navigation';
import { replaceUrlParams } from '../../app/utils'
import { ERROR_STRING } from '../../app/errors';
import {
    Header,
    Button,
    ErrorMark,
    SubSeparator
} from '../../components/RegularComponents'
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice'
import TopNavigationBar from "../TopNavigationBar"
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import { branchApplicationReviewSelect } from '../../redux/selector/branchApplicationReviewSelector';
import { setAllNewBranchApplicationsProperty } from '../../redux/slice/additionalApplicationsSlice';

const BranchApplicationReview = (props) => {
    const { branchApplicationReview, dispatch } = props
    const { applicationType, applicationMode } = props.match.params
    const { forChangeRequest } = props.location.state ?? false
    const [reviewDetails, setReviewDetails] = useState(branchApplicationReview.reviewDetails)

    useEffect(() => {
        setReviewDetails(branchApplicationReview.reviewDetails)
    }, [
        branchApplicationReview.reviewDetails,
        setReviewDetails
    ])

    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const handleAdditionalBranchesEdit = () => {
        dispatch(
            push(
                replaceUrlParams(
                    ROUTE_PATH.NEW_BRANCH_APPLICATION_DETAILS,
                    applicationType,
                    applicationMode
                )
            )
        )
    }

    const ReviewBody = () => (
        <div className="timeline row bottomMarginMedium">
            <div className="col-12">
                <ol>
                    <li className="timeline-item col-md-12">
                        <div className="step-content col-md-12 col-xs-12">
                            <span className="step-counter step-counter-circle">1</span>
                            <h3>Branch information</h3>
                            <div className="row">
                                <div className="col-lg-11">
                                    {
                                        reviewDetails.newBranches.map((data, index) => {
                                            return (
                                                <div key={"additional-banch-data-" + index}>
                                                    <ReviewForm data={data} />
                                                    {(index < reviewDetails.newBranches.length - 1)
                                                        && <SubSeparator />}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="col-lg-1">
                                    <Button
                                        id="edit-additional-branches"
                                        buttonType="regular_primary"
                                        text="Edit"
                                        onClick={handleAdditionalBranchesEdit}
                                    />
                                </div>
                            </div>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    )

    const ReviewAction = () => (
        <div className="row bottomMarginMedium">
            {!forChangeRequest ? (<div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                <Button
                    showSpinner={!applicationSaveError &&
                        (branchApplicationReview.applicationSavingRequestStatus
                            === REQUEST_STATUS.IN_PROGRESS)}
                    id="save-business-licence-application-data"
                    buttonType="regular_primary"
                    text={"Save and next"}
                    onClick={() => {
                        setApplicationSaveError(false)

                        dispatch(
                            setAllNewBranchApplicationsProperty({
                                key: 'userApplicationReviewComplete',
                                value: true,
                            })
                        );

                        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode, true))
                            .then(data => {
                                let nextUrl = branchApplicationReview.navigation.next
                                if (applicationMode === APPLICATION_MODE_RENEW) {
                                    nextUrl = branchApplicationReview.navigationRenewal.next
                                }
                                dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
                            })
                            .catch(err => {
                                setApplicationSaveError(true)
                            })
                    }}
                />
                {applicationSaveError && ErrorMark()}
                {applicationSaveError && <div className="help-block topMarginNormal">
                    {ERROR_STRING.APPLICATION_SAVE_ERROR}
                </div>}
            </div>) : (<div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                <Button 
                    showSpinner={!applicationSaveError &&
                        (branchApplicationReview.applicationSavingRequestStatus
                            === REQUEST_STATUS.IN_PROGRESS)}
                    text={applicationMode === APPLICATION_MODE_RENEW ? "Submit renewal request" : "Submit change request"}
                    buttonType="regular_primary"
                    onClick={() => {
                        setApplicationSaveError(false)
                        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                            .then(data => {
                                dispatch(push(replaceUrlParams(
                                    ROUTE_PATH.WELCOME, 
                                    applicationType, 
                                    applicationMode)))
                            })
                            .catch(err => {
                                setApplicationSaveError(true)
                            })
                    }}
                    id="submit-change-request-button"
                />
                {applicationSaveError && ErrorMark()}
                {applicationSaveError && <div className="help-block topMarginNormal">
                    {ERROR_STRING.APPLICATION_SAVE_ERROR}
                </div>}
            </div>)}
        </div>
    )

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar 
                    {...props} 
                    hideSaveAndExit={forChangeRequest} 
                />
                <Header header={'Branch application review'} />
                <ReviewBody />
                <ReviewAction />
            </div>
        </>
    );
}

export default connect(branchApplicationReviewSelect)(BranchApplicationReview)